import './index.css'

import { Component } from 'react'
import MonthYearPicker from '../month-year-picker'
import LabelMessage from '../utils/label-message'
import Switch from '../switch'
import dayjs from 'dayjs'

class PeriodPickerComponent extends Component {
  constructor(props) {
    super(props)

    this.state = { model: props.model }
  }

  updateDisable = () => {
    let period = this.state.model
    period.disabled = !period.disabled

    this.setState({ model: period })
    this.updatePeriod()
  }

  updateCurrently = () => {
    let period = this.state.model
    period.currently = !period.currently

    this.setState({ model: period })
    this.updatePeriod()
  }

  updateDate = (field, value) => {
    let period = this.state.model
    period[field] = value
    this.setState({ model: period })

    this.props.updatePeriod(this.props.field, this.state.model)
  }

  updatePeriod = () => {
    this.props.updatePeriod(this.props.field, this.state.model)
  }

  render() {
    return (
      <div className="text-input">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <LabelMessage
            label="Start & End Date"
            help="Complete with the start and end date, if you want, you can ignore this information."
          />

          <Switch
            label="Show Dates"
            value={this.state.model.disabled}
            updateDisable={this.updateDisable}
          />
        </div>

        <div className="period-picker-inputs-content">
          <MonthYearPicker
            field="startDate"
            value={this.state.model.startDate}
            isDisabled={this.state.model.disabled}
            showCurrently={false}
            updateDate={this.updateDate}
          />

          <MonthYearPicker
            field="endDate"
            value={this.state.model.endDate}
            isDisabled={this.state.model.disabled}
            isCurrently={this.state.model.currently}
            showCurrently={true}
            updateDate={this.updateDate}
            updateCurrently={this.updateCurrently}
          />
        </div>
      </div>
    )
  }
}

const today = dayjs().date(1).format('MM/DD/YYYY')
MonthYearPicker.defaultProps = {
  field: 'field',
  startDate: today,
  endDate: today,
  currently: false,
  disabled: false,
}

export default PeriodPickerComponent
